import Header from 'components/VerticalLayout/Header'
import React, { useState } from 'react'
import bgImage from '../../../../assets/images/bgImage1.jpg'
import useGetUsersCredits from '../hooks/useGetUsersCredits'
import { Button, Card, CardHeader, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner } from 'reactstrap'
import { Table, Tbody, Td, Thead, Tr } from 'react-super-responsive-table'
import { FaEdit } from 'react-icons/fa'
import EditWalletForm from '../components/EditWalletForm'
import EyeButton from 'pages/Ui/EyeButton/EyeButton'
import { IoAddCircleOutline } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";

 // Style object for the sticky table headers
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
  };

const UserCreditManagementPage = () => {

  // orgs data
  const orgsData = JSON.parse(localStorage.getItem('appInitData'))
  const orgs = orgsData?.organization || []

  // pagination
  const[currentPage,setCurrentPage]=useState(1);
  const pageSize = 10;

  // search term
  const[searchTerm,setSearchTerm]=useState('');

  // for filter
  const[orgFilter,setOrgFilter]=useState('')

  // hook to get users credit data
  const{isPending,isSuccess,isError,error,data} = useGetUsersCredits(currentPage,pageSize,searchTerm,orgFilter);

  const userCredits = data?.results || []
  const totalCount = data?.count || 0
  const totalPages = Math.ceil(totalCount/pageSize);
  console.log(userCredits)

  // for modal
  const[isEditMode,setIsEditMode]=useState(false);
  const[isSelectedWallet,setIsSelectedWallet]=useState(null);
  const[isOpen,setIsOpen]=useState();

   const AddModal=(wallet)=>{
    setIsEditMode(false);
    setIsSelectedWallet(wallet);
    setIsOpen(true);
  }

   const EditModal=(wallet)=>{
    setIsEditMode(true);
    setIsSelectedWallet(wallet);
    setIsOpen(true);
  }

  const closeModal=()=>{
    setIsEditMode(false);
    setIsSelectedWallet(null);
    setIsOpen(false);
  }

  return (
    <div className='account'>
          <Header/>
          <div className='accountbg'
            style={{
                background: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment:"fixed",
                paddingTop:"80px",
                minHeight:"100vh",
                overflowY:"auto",
                overflowX:"hidden",
                paddingLeft:"8px"
                }}
          >
            <Card className='p-4'>
            <div className='d-flex justidy-content-between align-items-center border-bottom pb-2 mb-4'>
              <div><h5 className='fw-bold'>Users Credit Management</h5></div>
              <div className='ms-4 mb-2'>
                {/* search */}
                <input
                    type="text" 
                    className="form-control"
                    placeholder="Search Organization..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{width:"850px"}}
                />
              </div>
              <div className='ms-4 mb-2'>
                {/* org filter */}
                <select
                  className="form-select"
                  value={orgFilter || ""}
                  style={{ width: '200px' }}
                  onChange={(e)=> setOrgFilter(e.target.value)}
                >
                  <option value="">Filter by Org</option>
                  {orgs.map((org,index)=>(
                    <option key={index} value={org.org_id}>{org.name}</option>
                  ))}
                </select>
              </div>
            </div>
              <Row className='g-3'>
                <Table className='table table-striped table-bordered'>
                  <Thead>
                    <Tr>
                      <Td style={stickyHeaderStyle}>SL.No</Td>
                      <Td style={stickyHeaderStyle}>Name</Td>
                      {/* <Td style={stickyHeaderStyle}>Email</Td> */}
                      <Td style={stickyHeaderStyle}>
                        Paid Credits <EyeButton message="Credits which are purchased"/>
                      </Td>
                      <Td style={stickyHeaderStyle}>
                        Free Credits <EyeButton message="Credits Provided free of Charge"/>
                      </Td>
                      <Td style={stickyHeaderStyle}>
                        Loaned Credits <EyeButton message="Credits added as a loan or debt that can be consumed for orders"/>
                      </Td>
                      <Td style={stickyHeaderStyle}>
                        Credit Line <EyeButton message="Credits added as a loan or debt that require repayment"/>
                      </Td>
                      <Td style={stickyHeaderStyle}>Actions</Td>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {isPending && (
                      <Tr>
                        <Td colSpan="5" className="text-center">
                          <Spinner color='primary'/>
                        </Td>
                      </Tr>
                    )}

                    {isError && (
                      <Tr>
                        <Td colSpan="18" className="text-center text-danger">
                          <h6>Error fetching data: {error.message}</h6>
                        </Td>
                      </Tr>
                    )}

                    {
                      !isPending && userCredits.length === 0 && (
                        <Tr>
                          <Td colSpan="18" className="text-center">
                            <div className="py-4">
                                <div className="d-flex flex-column align-items-center text-muted">
                                <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                                <h5 className="mb-1">No Data Found</h5>
                                </div>
                            </div>
                          </Td>
                        </Tr>
                      )
                    }
                    {
                      isSuccess && (
                        Array.isArray(userCredits) && 
                        userCredits.filter((userCredit)=>{
                          const term = searchTerm.toLowerCase();
                          const matchesSearch = userCredit.org_name?.toLowerCase().includes(term);
                          return matchesSearch;

                        }).map((userCredit,index)=>(
                          <Tr key={index}>
                            <Td>{index + 1}</Td>
                            <Td>{userCredit.org_name}</Td>
                            {/* <Td>{userCredit.email}</Td> */}
                            <Td>{`$${Number(userCredit.paid_credit).toLocaleString('en-us')}`}</Td>
                            <Td>{`$${Number(userCredit.free_credit).toLocaleString('en-us')}`}</Td>
                            <Td>{`$${Number(userCredit.debt_credit).toLocaleString('en-us')}`}</Td>
                            <Td>{`$${Number(userCredit.debt_owned).toLocaleString('en-us')}`}</Td>
                            <Td>
                              <div style={{ display: "flex", flexDirection: "row",alignItems:"center", gap:"0.5rem"}}>
                                  <Button
                                    style={{backgroundColor: "#00ADF0", color: "white",fontWeight: "bolder" }}
                                    size="sm"
                                    outline
                                    onClick={() => AddModal(userCredit)}
                                  >
                                    {<IoMdAdd />}
                                  </Button>
                                  <Button
                                    style={{backgroundColor: "#00ADF0", color: "white",fontWeight: "bolder" }}
                                    size="sm"
                                    outline
                                    onClick={() => EditModal(userCredit)}
                                  >
                                    {<FaEdit />}
                                  </Button>
                              </div>
                            </Td>
                          </Tr>
                        ))
                      )
                    }
                  </Tbody>
                </Table>
                <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
                    <Pagination size='sm' className='justify-content-center'>
                      {/* first page */}
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink
                          first
                          onClick={()=> setCurrentPage(1)}
                          style={{
                            backgroundColor: '#f8f9fa',
                            color: '#007bff',
                            border: '1px solid #dee2e6',
                            padding: '5px 10px',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                          }}
                        />
                      </PaginationItem>

                      {/* previous page */}
                      <PaginationItem disabled={currentPage === 1}>
                          <PaginationLink
                            previous
                            onClick={()=>setCurrentPage(prev => prev - 1)}
                            style={{
                              backgroundColor: '#f8f9fa',
                              color: '#007bff',
                              border: '1px solid #dee2e6',
                              padding: '5px 10px',
                              cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                          }}
                          />
                      </PaginationItem>

                      {/* page numbers */}
                      {[...Array(totalPages)].map((_,index)=>{
                      const isActive = currentPage === index + 1;
                      return(
                        <PaginationItem key={index} active={isActive}>
                          <PaginationLink
                            onClick={()=> setCurrentPage(index + 1)}
                            style={{
                              backgroundColor: isActive ? '#007bff' : '#fff',
                              color: isActive ? '#fff' : '#007bff',
                              border: '1px solid #dee2e6',
                              padding: '5px 12px',
                              margin: '0 2px',
                              cursor: 'pointer',
                              borderRadius: '4px',
                              fontWeight: isActive ? 'bold' : 'normal',
                            }}
                          >
                            {index + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )
                    })}

                    {/* next page */}
                    <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink
                          next
                          onClick={()=> setCurrentPage(prev => prev + 1)}
                          style={{
                            backgroundColor: '#f8f9fa',
                            color: '#007bff',
                            border: '1px solid #dee2e6',
                            padding: '5px 10px',
                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                          }}
                        />
                      </PaginationItem>
      
                      {/* last page */}
                      <PaginationItem disabled={currentPage === totalPages}>
                          <PaginationLink
                            last
                            onClick={()=> setCurrentPage(totalPages)}
                            style={{
                              backgroundColor: '#f8f9fa',
                              color: '#007bff',
                              border: '1px solid #dee2e6',
                              padding: '5px 10px',
                              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                            }}
                          />
                      </PaginationItem>
                    </Pagination>
                </div>
              </Row>

              {/* modal */}
              <Modal isOpen={isOpen} size='lg' backdrop="static" keyboard={false} toggle={null} fullscreen="xl" fade scrollable centered={true}>
                <ModalHeader close={<button type="button" className="btn-close" onClick={closeModal}/>}>
                    Update User Wallet
                </ModalHeader>
                <ModalBody>
                    <EditWalletForm isEditMode={isEditMode} walletData={isSelectedWallet} onClose={closeModal}/>
                </ModalBody>
              </Modal>
            </Card>
          </div>
    </div>
  )
}

export default UserCreditManagementPage
